<template>
  <div class="trip-exists-error">
    <p class="text-center text-red font-weight-bold text-decoration">
      There's currently an existing ride and here are the details:
    </p>
    <ul>
      <li>
        <strong>ETA: </strong>
        <span>{{ rideInfo.eta }}</span>
      </li>
      <li>
        <strong>Status: </strong>
        <span>{{ rideStatus }}</span>
      </li>
      <li>
        <strong>Start Location: </strong>
        <span>{{ rideInfo.startLocation }}</span>
      </li>
      <li>
        <strong>Destination: </strong>
        <span>{{ rideInfo.destination }}</span>
      </li>
      <li>
        <strong>Driver Name: </strong>
        <span>{{ rideInfo.driverName }}</span>
      </li>
      <li>
        <strong>Car: </strong>
        <span class="text-capitalize">{{ rideInfo.carDisplayName }}</span>
      </li>
      <li>
        <strong>Date Requested: </strong>
        <span>{{ rideCreatedAt }}</span>
      </li>
      <li v-if="!!rideInfo.mapUrl">
        <strong>Trip Map Link: </strong>
        <a
          :href="rideInfo.mapUrl"
          target="_blank"
        >Click here</a>
      </li>
    </ul>
    <p class="text-center">
      <span class="text-red">*IF*</span> the ride status is stuck in <span class="text-red">"START"</span> or
      <span class="text-red">"PROCESSING"</span> for awhile, please try cancelling the ride and ordering with specific vendor instead of
      just the default "car" option.
    </p>
    <hr class="mt-10">
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import _ from 'lodash';
import Moment from 'moment-timezone';

const props = defineProps({
  rideInfo: {
    type: Object,
    default: () => ({}),
  },
});

const rideStatus = computed(() => _.startCase(props.rideInfo.rideStatus));
const rideCreatedAt = computed(() => {
  const createdAtStr = Moment.utc(props.rideInfo.createdAt).format('ddd, MMM DD, YYYY h:mm A');

  return `${createdAtStr} (Coordinated Universal Time)`;
});
</script>
